'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompanyService = function () {
  function CompanyService($http) {
    'ngInject';

    _classCallCheck(this, CompanyService);

    this.$http = $http;
  }

  _createClass(CompanyService, [{
    key: 'getCompany',
    value: function getCompany(id) {
      return this.$http.get('/api/member/' + id);
    }
  }, {
    key: 'update',
    value: function update(company) {
      return this.$http.put('/api/member/' + company.MemberId, company);
    }
  }, {
    key: 'add',
    value: function add(company) {
      return this.$http.post('/api/member', company);
    }
  }, {
    key: 'updateCompliance',
    value: function updateCompliance(company) {
      return this.$http.put('/api/member/' + company.MemberId + '/compliance', company);
    }
  }, {
    key: 'getDefaultQuery',
    value: function getDefaultQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        orderBy: 'MemberName',
        direction: 'asc'
      });
    }

    /* eslint-disable max-len */

  }, {
    key: 'search',
    value: function search(query) {
      return this.$http.get('/odata/MemberOData', {
        params: _extends({
          $select: 'MemberId, MemberName, IsActive, IsLogOut, IsRequireMonthlyCompliance, IsNascAudited, DateBecameAudited',
          $top: query.take
        }, query.page && { $skip: query.calculateSkip() }, {
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
    /* eslint-enable max-len */

  }]);

  return CompanyService;
}();

exports.default = CompanyService;


// WEBPACK FOOTER //
// ./services/company.service.js